import { useEffect, useState } from "react";
import axios from "axios";
import { Reveal } from "./Reveal";
import { WaitlistForm } from "./WaitlistForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CTA = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/waitlist/count`)
      .then(({ data }) => setCount(data.count))
      .catch(() => {});
  }, []);

  return (
    <section id="join" className="relative overflow-hidden border-t border-[#1F1F1F] bg-black py-28 md:py-40">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[700px] -translate-x-1/2 rounded-full bg-[#C9A94B] opacity-[0.08] blur-[130px]" />

      <div className="mx-auto max-w-3xl px-5 text-center md:px-10">
        <Reveal>
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#C9A94B]">
            [ Get early access ]
          </span>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-6xl uppercase leading-[0.85] tracking-tight text-white md:text-8xl">
            Prove it to<br />yourself.
          </h2>
          <p className="mx-auto mt-6 max-w-md font-body text-base leading-relaxed text-[#A1A1AA]">
            Join the waitlist for prooftous.app. We&apos;ll send you a confirmation now and early access
            the moment it opens.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-10 flex flex-col items-center">
            <WaitlistForm size="large" testidPrefix="cta" />
            <div className="mt-5 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5A5A5A]">
              <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-[#516A38]" />
              {count !== null ? `${count} already on the ledger` : "Building the ledger"}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
